import { useSelector } from 'react-redux';

const useCurrentUser = () => {
    const user = useSelector((state) => state.user.user);

    const permissions = {};
    const separatePermissions = {};

    if (user) {
        user.role?.permissions.forEach((permission) => {
            if (!permission.organization_id) {
                if (!('general' in separatePermissions)) {
                    separatePermissions['general'] = {};
                }

                separatePermissions['general'][permission.permission] = {
                    create: permission.create,
                    read: permission.read,
                    update: permission.update,
                    delete: permission.delete
                };

                permissions[permission.permission] = {
                    create: permission.create,
                    read: permission.read,
                    update: permission.update,
                    delete: permission.delete
                };
            } else {
                if (!(permission.organization_id in separatePermissions)) {
                    separatePermissions[permission.organization_id] = {};
                }

                separatePermissions[permission.organization_id][permission.permission] = {
                    create: permission.create,
                    read: permission.read,
                    update: permission.update,
                    delete: permission.delete
                };

                if (!(permission.permission in permissions)) {
                    permissions[permission.permission] = {
                        create: permission.create,
                        read: permission.read,
                        update: permission.update,
                        delete: permission.delete
                    };
                } else {
                    permissions[permission.permission]['create'] =
                        permissions[permission.permission]['create'] || permission.create;
                    permissions[permission.permission]['read'] =
                        permissions[permission.permission]['read'] || permission.read;
                    permissions[permission.permission]['update'] =
                        permissions[permission.permission]['update'] || permission.update;
                    permissions[permission.permission]['delete'] =
                        permissions[permission.permission]['delete'] || permission.delete;
                }
            }
        });
    }

    return {
        user,
        permissions,
        separatePermissions
    };
};

export default useCurrentUser;
